import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-102">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-103">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-104">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-105">
              <h2 className="text-xl font-bold text-dark font-serif" data-id="element-106">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-dark-light" aria-label="Cerrar" data-id="element-107">
                <XIcon size={20} data-id="element-108" />
              </button>
            </div>
            <div className="px-6 py-6 overflow-y-auto text-dark-light text-sm leading-relaxed space-y-4" data-id="element-109">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}